export default function round(num) {
  return parseFloat(num.toFixed(2))
}